import React, { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Menu, MenuItem, Divider, IconButton, Theme } from "@mui/material";
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useTranslation } from "react-i18next";
import AuthContext from "../../services/Auth/AuthContext";
import config from "../../config";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { getRidersTemplateUrl } from '../../i18n/helper';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grow: {
            flexGrow: 1,
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        sectionMobile: {
            display: 'flex',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        }
    }));

interface ISpecialMenuProps {
    handleClose: any;
}

function OrganizerMenu(props: ISpecialMenuProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (<React.Fragment>
        <MenuItem onClick={() => {
            navigate('/events/organizer');
            props.handleClose();
        }}>{t("organizer.manageEvents")}</MenuItem>


        <Divider />
    </React.Fragment>);
}

function AdminMenu(props: ISpecialMenuProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (<React.Fragment>
        <MenuItem onClick={() => {
            navigate('/admin/circuits');
            props.handleClose();
        }}>{t("admin.manageCircuits")}</MenuItem>
        <MenuItem onClick={() => {
            navigate('/admin/readers');
            props.handleClose();
        }}>{t("admin.manageReaders")}</MenuItem>
        <MenuItem onClick={() => {
            navigate('/admin/tags');
            props.handleClose();
        }}>{t("admin.manageTags")}</MenuItem>
        <MenuItem onClick={() => {
            navigate('/admin/monitoring');
            props.handleClose();
        }}>{t("admin.monitoring")}</MenuItem>
        <MenuItem onClick={() => {
            navigate('/admin/users');
            props.handleClose();
        }}>{t("admin.manageUsers")}</MenuItem>
        <MenuItem onClick={() => {
            navigate('/admin/poison-queues');
            props.handleClose();
        }}>{t("admin.poisonQueues")}</MenuItem>
        <MenuItem onClick={() => {
            navigate('/admin/discarded-tags');
            props.handleClose();
        }}>{t("admin.manageDiscardedTags")}</MenuItem>
        <Divider />
    </React.Fragment>);
}

const menuId: string = 'primary-search-account-menu';

interface IMenuProps {
    isMenuOpen: boolean;

    anchorEl: HTMLElement | null;
    handleMenuClose: any;
}

export function LoginMenu(props: IMenuProps) {
    const { t, i18n } = useTranslation('common');
    const navigate = useNavigate();
    const isMenuOpen: boolean = props.isMenuOpen;

    const anchorEl: HTMLElement | null = props.anchorEl;
    const handleMenuClose: any = props.handleMenuClose;

    const authService = useContext(AuthContext);
    if (!authService) {
        console.log("sapristi!");
    }
    const isLoggedIn: boolean = authService?.isLoggedIn() === true;
    const ridersTemplateUrl = getRidersTemplateUrl(i18n.resolvedLanguage ?? i18n.language);

    if (isLoggedIn) {
        const canAccessRidersTemplate = authService?.isInRole(
            config.managementGroups.organizer,
            config.managementGroups.administrator
        ) === true;

        const handleLogout = () => {
            if (authService == null) {
                console.log("authService is null!!!");
            }
            authService?.logout();
            handleMenuClose();
        };
        return (
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                id={menuId}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >

                {/* <MenuItem onClick={() => authService?.editProfile()}>{t("user.profile")}</MenuItem> */}
                <MenuItem onClick={() => {
                    navigate("/user/profile");
                    handleMenuClose();
                }}>{t("user.profile")}</MenuItem>
                <MenuItem onClick={() => {
                    navigate("/user/history");
                    handleMenuClose();
                }}>{t("user.myTime")}</MenuItem>
                <MenuItem onClick={() => {
                    navigate("/user/tags");
                    handleMenuClose();
                }}>{t("user.stickerManagement")}</MenuItem>
                <Divider />
                {canAccessRidersTemplate &&
                    <MenuItem
                        component="a"
                        href={ridersTemplateUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleMenuClose}
                    >{t("eventsetup.ridersTemplate")}</MenuItem>
                }
                {authService?.isInRole(config.managementGroups.organizer) === true &&
                    <OrganizerMenu handleClose={handleMenuClose}></OrganizerMenu>
                }
                {authService?.isInRole(config.managementGroups.administrator) === true &&
                    <AdminMenu handleClose={handleMenuClose}></AdminMenu>

                }
                <MenuItem onClick={handleLogout}>{t("user.logout")}</MenuItem>
            </Menu>
        );
    } else {
        const handleLogin = () => {
            if (authService == null) {
                console.log("authService is null!!!");
            }
            authService?.login();
            handleMenuClose();
        };
        // const handleServerLogin = () => {
        //     window.location.href = 'https://localhost:5001/Identity/Account/Login';
        // };
        return (
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                id={menuId}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                {/* <MenuItem onClick={() => {
                    navigate("/account/login");
                    handleMenuClose();
                }}>{t("user.login")} - react</MenuItem>
                <Divider />
                <MenuItem onClick={handleServerLogin}>{t("user.login")} - server</MenuItem>
                <Divider /> */}
                <MenuItem onClick={handleLogin}>{t("user.login")}</MenuItem>
            </Menu>
        );
    }

}

interface ILoginControlProps {
    profileAnchorEl: HTMLElement | null;
    handleProfileMenuOpen: ((event: any) => void) | undefined;
    handleProfileMenuClose: ((event: any) => void) | undefined;
}
function LoginControl(props: ILoginControlProps) {
    const classes = useStyles();


    const isMenuOpen = Boolean(props.profileAnchorEl);
    return <>
        <div className={classes.grow} />
        <div className={classes.sectionDesktop}>
            <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={props.handleProfileMenuOpen}
                color="inherit"
                size="large">
                <AccountCircle />
            </IconButton>
        </div>
        <LoginMenu
            isMenuOpen={isMenuOpen}
            anchorEl={props.profileAnchorEl}
            handleMenuClose={props.handleProfileMenuClose} />
    </>;

}

export default LoginControl;

